//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Children_bacterial_meningitis_score",
  data() {
    return {
      form: {
        positiveGramStaining: "",
        cerebrospinalFluidProtein: "",
        peripheralBlood: "",
        epilepsy: "",
        cerebrospinalFluid:"",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "阴性" },
        { value: "2", name: "阳性" },
      ],
      dataList2: [
        { value: "0", name: "阴性" },
        { value: "1", name: "阳性" },
      ],
      dataList3: [
        { value: "0", name: "阴性" },
        { value: "1", name: "阳性" },
      ],
      dataList4: [
        { value: "0", name: "阴性" },
        { value: "1", name: "阳性" },
      ],
      dataList5: [
        { value: "0", name: "阴性" },
        { value: "1", name: "阳性" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Children_bacterial_meningitis_score.vue